
export class FormSupportRequest {
  healthsystem_name: string
  email: string
  request_content: string

  org_id: string
  org_name: string
  version: string
  arch: string
  os: string


  //these fields will be filled out if an error occured while connecting the account
  error?: string
  error_description?: string

  brand_id?: string
  portal_id?: string
  endpoint_id?: string
  org_connection_id?: string
  vault_profile_connection_id?: string

  external_id?: string
  external_state?: string
  request_id?: string
}
